/**
 * @fileOverview The main entry point to your standalone. Start editing here.
 */

import React from 'react'

import '@ta-interaktiv/semantic-ui/semantic/dist/components/icon.css'
import './styles.scss'
import { parseHostname } from '@ta-interaktiv/parse-hostname'
import Tab from 'components/tab'
import { Accordion, Image, List } from 'semantic-ui-react'

let baseUrl = window.location.hostname.replace('interaktiv.', '')
baseUrl = baseUrl.replace('.ch', '')
baseUrl.replace(new RegExp('.', 'g'), '')

export class SchutzMassnahmen extends React.Component<Props, State> {
  constructor(props) {
    super(props)
    this.state = {
      activeIndex: [-1]
    }
  }

  handleClick = (e, titleProps) => {
    const { index } = titleProps
    const { activeIndex } = this.state
    // const newIndex = activeIndex === index ? -1 : index
    // this.setState({ activeIndex: newIndex })
    const openIndex = activeIndex.indexOf(index)
    console.log('openIndex: ', openIndex)
    if (openIndex === -1) {
      const newArray = this.state.activeIndex.slice()
      newArray.push(index)
      this.setState({ activeIndex: newArray })
    } else {
      const newArray = this.state.activeIndex
      newArray.splice(openIndex, 1)
      this.setState({ activeIndex: newArray })
    }

    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
      event: 'Interactions',
      event_action: 'click',
      event_label: 'toggle tab: ' + titleProps.index
    })
  }

  componentDidMount() {
    const domain = parseHostname().publicationDomain
  }

  render() {
    return (
      <div
        className='index'
        id='tab'
        style={{ marginTop: '2rem', marginBottom: '2rem' }}
      >
        <Accordion fluid styled>
          <Tab
            activeIndex={this.state.activeIndex}
            index={0}
            handleClick={this.handleClick}
            title='So können Sie sich schützen'
          >
            <List>
              <List.Item>
                <div className='centered'>
                  <Image
                    avatar
                    size='small'
                    src={require('./images/haende.svg')}
                  />
                </div>
                <List.Content>
                  <List.Description>
                    <p>
                      Die meisten Infektionskrankheiten werden über die Hände
                      übertragen.{' '}
                      <span className='highlighted'>Waschen Sie die Hände</span>{' '}
                      mehrmals täglich gründlich mit Wasser und Seife oder
                      nutzen Sie ein Hände-Desinfektionsmittel.
                    </p>
                    <p className='readmore'>
                      <span className='hint'>Lesen Sie auch</span>
                      <a
                        href={
                          'https://interaktiv.' +
                          baseUrl +
                          '.ch/2020/richtig-haendewaschen/?nosome'
                        }
                        target='_blank'
                      >
                        <i className='file alternate outline icon' />{' '}
                        <span className='headline'>
                          Das Einzige, das vor Viren schützt – und alle machen
                          es falsch
                        </span>
                      </a>
                    </p>
                  </List.Description>
                </List.Content>
              </List.Item>
              <List.Item>
                <div className='centered'>
                  <Image
                    avatar
                    size='small'
                    src={require('./images/husten.svg')}
                  />
                </div>
                <List.Content>
                  <List.Description>
                    <p>
                      Beim Husten und Niesen ein Taschentuch oder die Armbeuge
                      vor Mund und Nase halten. Wenn immer möglich ein{' '}
                      <span className='highlighted'>
                        Papiertaschentuch verwenden.
                      </span>
                      Das Taschentuch nach Gebrauch in geschlossenen Abfalleimer
                      entsorgen und die Hände waschen.
                    </p>
                  </List.Description>
                </List.Content>
              </List.Item>
              <List.Item>
                <div className='centered'>
                  <Image
                    avatar
                    size='small'
                    src={require('./images/abstand.svg')}
                  />
                </div>
                <List.Content>
                  <List.Description>
                    <p>
                      Vermeiden Sie direkten Kontakt mit anderen Personen.{' '}
                      <span className='highlighted'>Kein Händeschütteln</span>{' '}
                      oder Begrüssungsküsse. Wenn möglich{' '}
                      <span className='highlighted'>
                        <nobr>2 Meter</nobr> Abstand halten.
                      </span>
                      Aktivitäten in der Gruppe vermeiden.
                    </p>
                    <p className='readmore'>
                      <span className='hint'>Lesen Sie auch</span>
                      <a
                        href={
                          'https://interaktiv.' +
                          baseUrl +
                          '.ch/2020/so-steckt-man-sich-mit-dem-neuen-coronavirus-an/?nosome'
                        }
                        target='_blank'
                      >
                        <i className='file alternate outline icon' />{' '}
                        <span className='headline'>
                          Wie sich das Coronavirus verbreitet — und wie nicht
                        </span>
                      </a>
                    </p>
                  </List.Description>
                </List.Content>
              </List.Item>
              <List.Item>
                <div className='centered'>
                  <Image
                    avatar
                    size='small'
                    src={require('./images/reinigen.svg')}
                  />
                </div>
                <List.Content>
                  <List.Description>
                    <p>
                      <span className='highlighted'>
                        Gegenstände und Oberflächen zu reinigen
                      </span>{' '}
                      ist ein wirksames Mittel, um sich vor Ansteckung zu
                      schützen. Kontaktoberflächen (Türgriffe, Möbel,
                      Toilettenschüssel, etc.) werden regelmässig mit heissem
                      Wasser, Seife oder den gängigen Haushaltprodukten
                      gereinigt.
                    </p>
                  </List.Description>
                </List.Content>
              </List.Item>
              <List.Item>
                <div className='centered'>
                  <Image
                    avatar
                    size='small'
                    src={require('./images/zuhause.svg')}
                  />
                </div>
                <List.Content>
                  <List.Description>
                    <p>
                      <span className='highlighted'>
                        Bei Fieber und Husten zu Hause bleiben.{' '}
                      </span>
                      Suchen Sie nur nach telefonischer Anmeldung eine
                      Arztpraxis oder Notfallstation auf.
                    </p>
                  </List.Description>
                </List.Content>
              </List.Item>
              <List.Item>
                <div className='centered'>
                  <Image
                    avatar
                    size='small'
                    src={require('./images/hygienemaske.svg')}
                  />
                </div>
                <List.Content>
                  <List.Description>
                    <p>
                      In erster Linie sollen{' '}
                      <span className='highlighted'>
                        Kranke eine Hygienemaske tragen
                      </span>
                      , um die Übertragung von Krankheitserregern auf ihre
                      Umgebung zu reduzieren. Hygienemasken sind nur zusammen
                      mit den anderen Hygienemassnahmen und Verhaltensregeln
                      sinnvoll.
                    </p>
                  </List.Description>
                </List.Content>
              </List.Item>
            </List>
            <hr />
            <p>
              <strong>Infoline des Bundes</strong>
              <br />
              Telefonnummer 058 463 00 00
              <br />
              Täglich 24 Stunden erreichbar.
              <br />
              Auf der{' '}
              <a
                href='https://www.bag.admin.ch/bag/de/home/krankheiten/ausbrueche-epidemien-pandemien/aktuelle-ausbrueche-epidemien/novel-cov.html'
                target='_blank'
              >
                Webseite des BAG gibt es tagesaktuelle Informationen
              </a>
              .
            </p>
            <p className='source'>
              Quelle:{' '}
              <a
                href='https://www.bag.admin.ch/bag/de/home/krankheiten/ausbrueche-epidemien-pandemien/hygiene-pandemiefall/verhaltensregeln-oeffentlichkeit.html'
                target='_blank'
              >
                Bundesamt für Gesundheit
              </a>
              <br />
              Umsetzung: lm, Tamedia Interaktiv-Team
            </p>
          </Tab>
        </Accordion>
      </div>
    )
  }
}
